<p><strong>49 CFR Part 382.301</strong></p>
<p><strong>382.301 Pre-employment testing.</strong></p>
<p>
  a Prior to the first time a driver performs safety-sensitive functions for an employer, the driver shall undergo
  testing for controlled substances as a condition prior to being used, unless the employer uses the exception in
  paragraph (b) of this section. No employer shall allow a driver, who the employer intends to hire or use, to perform
  safety-sensitive functions unless the employer has received a controlled substances test result from the MRO or C/TPA
  indicating a verified negative test result for that driver.
</p>
<p>
  b An employer is not required to administer a controlled substances test required by paragraph (a) of this section if:
</p>
<p>
  (1) The driver has participated in a controlled substance testing program that meets the requirements of this part
  within the previous 30 days: and
</p>
<p>(2) While participating in that program, either:</p>
<p>
  (i) Was tested for controlled substances within the past 6 months (from the date of application with the employer) or
</p>
<p>
  (ii) Participated in the random controlled substances testing program for the previous 12 months (from the date of
  application with the employer); and
</p>
<p>
  (3) The employer ensures that no prior employer of the driver of whom the employer has knowledge has records of a
  violation of this part or the controlled substances use rule of another DOT agency within the previous six months.
</p>
<p>
  (c) (1) An employer who exercises the exception in paragraph (b) of this section shall contact the controlled
  substances testing program(s) in which the
</p>
<p>
  driver participates or participated and shall obtain and retain from the testing program(s) the following information:
</p>
<ul>
  <li>
    Name(s) and address(es) of the program(s).
  </li>
  <li>Verification that the driver participates or participated in the program(s).</li>
  <li>Verification that the program(s) conforms to part 40 of this title.</li>
  <li>
    Verification that the driver is qualified under the rules of this part, including that the driver has not refused to
    be tested for controlled substances.
  </li>
  <li>The date the driver was last tested for controlled substances.</li>
  <li>
    The results of any tests taken within the previous six months and any other violations of subpart B of this part
  </li>
</ul>
<p>
  (2) An employer who uses but does not employ a driver more than once a year to operate commercial motor vehicles must
  obtain the information in paragraph (c)(1) of this section at least once every six months. The records prepared under
  this paragraph shall be maintained in accordance with § 382.401. If the employer cannot verify that the driver is
  participating in a controlled substance testing program in accordance with this part and part 40 of this title, the
  employer shall conduct a pre employmentcontrolled substances test.
</p>
<p>
  (d) An employer may, but is not required to, conduct pre-employment alcohol testing under this part. If an employer
  chooses to conduct pre-employment alcohol testing, it must comply with the following requirements:
</p>
<p>
  (1) It must conduct a pre-employment alcohol test before the first performance of safety-sensitive functions by every
  covered employee (whether a new employee or someone who has transferred to a position involving the performance of
  safety-sensitive functions).
</p>
<p>
  (2) It must treat all safety-sensitive employees performing safety-sensitive functions the same for the purpose of
  pre-employment alcohol testing (i.e., it must not test some covered employees and not others).
</p>
<p>
  (3) It must conduct the pre-employment tests after making a contingent offer of employment or transfer, subject to the
  employee passing the pre-employment alcohol test.
</p>
<p>
  (4) It must conduct all pre-employment alcohol tests using the alcohol testing procedures of 49 CFR part 40 of this
  title.
</p>
<p>
  (5) It must not allow a covered employee to begin performing safety-sensitive functions unless the result of the
  employee's test indicates an alcohol concentration of less than 0.04.
</p>

<p class="page-number">Page 5 of 30</p>
